import {Component, inject, OnDestroy} from '@angular/core';
import {AuthService, SharedDataAccessUserModule, UserService} from "@lcms/shared/data-access-user";
import {Router, RouterModule} from "@angular/router";
import {map} from "rxjs";
import {SubSink} from "subsink";
import {TranslationService} from "@lcms/shared/i18n";
import {TranslateModule} from "@ngx-translate/core";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'lcms-terms-cgu',
  standalone : true,
  imports: [
    TranslateModule,
    SharedDataAccessUserModule,
    CommonModule,RouterModule
  ],
  templateUrl: './terms-cgu.component.html',
  styleUrls: ['./terms-cgu.component.scss'],
})
export class TermsCGUComponent implements OnDestroy{
  subs = new SubSink();
  translation = inject(TranslationService)
  content$ =  this.userService.HtmlTerms().pipe(
    map((data)=>
      data.content
    )
  )
  hidespinner = true
  user$=this.userService.getUserData$
  constructor(private userService : UserService , private  router : Router , private authService : AuthService ) {
  }
  acceptTerms(user : any ) {
    this.hidespinner = false
     user.conditions_accepted = true
    console.log('testtt', user)
    this.userService.updateTerms(user).subscribe((data : any)=>{
      //this.serviceUser.termsU$.next(data.data.conditions_accepted)

  this.router.navigate(['/'])
      }
    )

  }
  logout() {
    console.log('logout'),
   this.subs.sink=  this.authService.logout().subscribe();

  }

  ngOnDestroy(): void {
    this.subs.unsubscribe()
  }
}
